/**
 * 
 * @baseUrl http统一请求地址
 * 
 */
let baseUrl = '..';
let baseIp = ""

if (process.env.NODE_ENV == 'development') {
  baseUrl = 'http://192.168.0.186';
  baseUrl = "http://192.168.0.252"
  baseUrl = 'http://127.0.0.1';
  // baseUrl = 'http://192.168.0.17'
  // baseUrl = 'http://dsc.zongteng.me'
  // baseUrl = 'http://192.168.0.110:5200'
  // baseUrl = 'http://192.168.0.144'
  // baseUrl = 'https://dev.ebistrategy.com'

  baseUrl = "http://192.168.6.118"
  //baseUrl = 'http://10.172.92.172'

   baseUrl = "https://dataportal.elcompanies.cn";
  // baseUrl = 'http://reportportal.nestlechinese.com';
  // baseUrl = 'http://192.168.0.129'
  // baseUrl = 'http://106.75.28.195'
   baseUrl = 'http://127.0.0.1'

  // baseUrl = "http://dsc.zongteng.me:5250"
  baseIp = "192.168.0.195" //留待websocket测试用
}

export { baseUrl, baseIp }